module.exports = __webpack_public_path__ + "staticmedia/media/OpenSans-Regular.629a55a7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/fonts/OpenSans-Regular.ttf
// module id = 107
// module chunks = 0